import React from "react";
import { Box } from "@mui/material";

function IconCircle({ bgcolor, children, sx }) {
  return (
    <Box
      sx={{
        width: 48,
        height: 48,
        borderRadius: "50%",
        bgcolor,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexShrink: 0,
        ...sx,
      }}
    >
      {children}
    </Box>
  );
}

export default IconCircle;
